module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche P3 (Version 1).c357478ffa63ea2e45747d7fc8a150ea.pdf";